import React, { useEffect, useState } from "react";
import { ListGroup } from "react-bootstrap";
import { editorProjectServices } from "../../APIServices/Editor/editorProjectServices";
import { NoDataFoundTable, PageLoader } from "../../Components/NoDataFoundTable/NoDataFoundTable";

function PackageManagementSidebar({
  collapseSidebar,
  checkActiveTabData,
  handleAddNewTab,
  openModule
}) {
  const [packageList, setPackageList] = useState([]);
  const [loader, setLoader] = useState(false);
  let objectIds = checkActiveTabData("packageData")?.ids
  const getOnlyPackageList = async (e) => {
    setLoader(true);
    let data = await editorProjectServices.getOnlyPackageList();
    setPackageList(data?.data || []);
    setLoader(false);
  };

  useEffect(() => {
    getOnlyPackageList();
  }, [openModule]);
  return (
    <>
      <ListGroup.Item action
        className={`border-0 border-bottom bg-light`}
        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
      >
        <div className="hstack justify-content-between w-100">
          <span>
            <i className={`fa-solid fa-cube me-2`}></i>
            {!collapseSidebar && <span>Package Management</span>}
          </span>
        </div>
      </ListGroup.Item>
      <div style={{ height: "calc(100vh - 147px)", overflowY: "auto" }}>
        {loader ? (!collapseSidebar &&
          <PageLoader />
        ) : packageList?.length === 0 ? (
          <NoDataFoundTable MSG={!collapseSidebar && "Packages not found!"} />
        ) : (
          packageList?.map((item, index) => (
            <ListGroup.Item key={index} action
              className={`border-0 border-bottom ${objectIds?.packageId === item.packageId && "selectedMenu"}`}
              style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
              onClick={() => {
                handleAddNewTab(
                  item.name,
                  "fa-solid fa-clipboard-list",
                  `packageData_${item.packageId}`,
                  item
                )
              }}
              title={item.name}
            >
              <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
              {!collapseSidebar && <span>{item.name}</span>}
            </ListGroup.Item>
          )))}
      </div>
    </>
  );
}

export default PackageManagementSidebar;